import { Link, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useSessao } from "../estado/sessao";
import { NavInferior } from "./NavInferior";
import {
  IconeCalendario,
  IconeCasa,
  IconePredio,
  IconePrancheta,
} from "./Icones";

const ITENS_LATERAIS = [
  { rota: "/painel", rotulo: "Dashboard", Icone: IconeCasa, ativa: (p: string) => p === "/painel" },
  { rota: "/vistorias", rotulo: "Vistorias", Icone: IconePrancheta, ativa: (p: string) => p.startsWith("/vistorias") },
  { rota: "/tarefas", rotulo: "Tarefas", Icone: IconePrancheta, ativa: (p: string) => p.startsWith("/tarefas") },
  { rota: "/agenda", rotulo: "Agenda", Icone: IconeCalendario, ativa: (p: string) => p.startsWith("/agenda") },
  { rota: "/clientes", rotulo: "Prédios", Icone: IconePredio, ativa: (p: string) => p.startsWith("/clientes") },
];

export function Layout({ children }: { children: ReactNode }) {
  const { usuario, sair } = useSessao();
  const { pathname } = useLocation();

  if (usuario?.papel === "SUPER_ADMIN") {
    return <div className="app plataforma-app">
      <aside className="sidebar-desktop">
        <Link to="/admin-geral" className="sidebar-marca">
          <span className="sidebar-marca-icone"><IconePrancheta tamanho={19} cor="#fff" /></span>
          <span><strong>PLATAFORMA</strong><small>Administração geral</small></span>
        </Link>
        <nav className="sidebar-nav" aria-label="Navegação da plataforma">
          <Link to="/admin-geral" className={pathname.startsWith("/admin-geral") ? "sidebar-link ativo" : "sidebar-link"}><IconeCasa tamanho={18} cor="currentColor" /> Visão geral</Link>
        </nav>
        <div className="sidebar-usuario"><span className="sidebar-avatar">{usuario.nome.slice(0, 1).toUpperCase()}</span><Link to="/perfil"><strong>{usuario.nome}</strong><small>Superadministrador</small></Link><button className="sidebar-sair" type="button" onClick={() => void sair()} aria-label="Sair"><span aria-hidden="true">↗</span><span>Sair</span></button></div>
      </aside>
      <header className="barra-topo"><Link to="/admin-geral" className="marca-topo">Plataforma</Link><nav className="nav-topo"><Link className={pathname.startsWith("/admin-geral") ? "aba ativa" : "aba"} to="/admin-geral">Visão geral</Link></nav><div className="barra-topo-direita"><span>Administração geral</span><button className="botao botao-texto" onClick={() => void sair()}>Sair</button></div></header>
      <div className="conteudo-app">{children}</div>
      <NavInferior />
    </div>;
  }

  return (
    <div className="app">
      <aside className="sidebar-desktop">
        <Link to="/painel" className="sidebar-marca">
          <span className="sidebar-marca-icone"><IconePrancheta tamanho={19} cor="#fff" /></span>
          <span><strong>VISTORIAS</strong><small>Predial</small></span>
        </Link>
        <nav className="sidebar-nav" aria-label="Navegação principal">
          {ITENS_LATERAIS.map(({ rota, rotulo, Icone, ativa }) => (
            <Link key={rota} to={rota} className={ativa(pathname) ? "sidebar-link ativo" : "sidebar-link"}>
              <Icone tamanho={18} cor="currentColor" /> {rotulo}
            </Link>
          ))}
          <div className="sidebar-divisor" />
          {usuario?.papel === "ADMIN" && (
            <>
              <Link to="/templates" className={pathname.startsWith("/templates") ? "sidebar-link ativo" : "sidebar-link"}>
                <IconePrancheta tamanho={18} cor="currentColor" /> Modelos
              </Link>
              <Link to="/equipe" className={pathname.startsWith("/equipe") ? "sidebar-link ativo" : "sidebar-link"}>
                <IconePredio tamanho={18} cor="currentColor" /> Equipe
              </Link>
            </>
          )}
        </nav>
        <div className="sidebar-usuario">
          <span className="sidebar-avatar">{usuario?.nome?.slice(0, 1).toUpperCase()}</span>
          <Link to="/perfil"><strong>{usuario?.nome}</strong><small>{usuario?.papel === "ADMIN" ? "Administrador" : "Vistoriador"}</small></Link>
          <button className="sidebar-sair" type="button" onClick={() => void sair()} aria-label="Sair"><span aria-hidden="true">↗</span><span>Sair</span></button>
        </div>
      </aside>
      <header className="barra-topo">
        <Link to="/painel" className="marca-topo">
          Vistor<span>IA</span>
        </Link>
        <nav className="nav-topo">
          <Link className={pathname === "/painel" ? "aba ativa" : "aba"} to="/painel">
            Painel
          </Link>
          <Link className={pathname.startsWith("/clientes") ? "aba ativa" : "aba"} to="/clientes">
            Prédios
          </Link>
          {usuario?.papel === "ADMIN" && <Link className={pathname.startsWith("/templates") ? "aba ativa" : "aba"} to="/templates">Modelos</Link>}
          <Link className={pathname.startsWith("/agenda") ? "aba ativa" : "aba"} to="/agenda">
            Agenda
          </Link>
          <Link className={pathname.startsWith("/vistorias") ? "aba ativa" : "aba"} to="/vistorias">
            Vistorias
          </Link>
          {usuario?.papel === "ADMIN" && (
            <Link className={pathname.startsWith("/equipe") ? "aba ativa" : "aba"} to="/equipe">
              Equipe
            </Link>
          )}
        </nav>
        <div className="barra-topo-direita">
          <span>{usuario?.organizacaoNome}</span>
          <button className="botao botao-texto" onClick={() => void sair()}>
            Sair
          </button>
        </div>
      </header>

      <div className="conteudo-app">{children}</div>

      <NavInferior />
    </div>
  );
}
